import "./wheelprize.css";
import PostSpinModal from "./PostSpinModal";
import { useNavigate } from "react-router-dom";
import arrow from "../../assets/icons/triangle.svg";
import TopUpModal from "../TopupModal/TopUpModal";
import { useEffect, useState, useRef } from "react";
import clickSound from "../../assets/sound/new.mp3";
import NetworkErrorModal from "./NetworkErrorModal";
import { RefreshCw } from "lucide-react";
import {
  globalGradientLightColors,
  globalGradientDarkColorsWheel,
  getPriceDarkBorderColor,
} from "../../utils/GlobalConstants";
import { useSelector, useDispatch } from "react-redux";
import { setAccount } from "../../redux/slices/accountSlice";
import { toggleOnboard } from "../../redux/slices/onBoardingSlice";
import {
  spinFree,
  spinWheel,
  getAccountBalance,
} from "../../api/modules/b2droppie.class";
import { Zap } from "lucide-react";
import Toaster from "../Toast/Toast";
import { syncUserData } from "../../services/userSync.service";
import { updateUserData } from "../../redux/slices/authSlice";
import Loading from "../Loader/Loading";
import SpinBackground from "../../assets/images/spinBackground.png";
import { ShieldCheck, ChevronLeft } from "lucide-react";
import { routes } from "../../routes";
import { AiFillSafetyCertificate } from "react-icons/ai";
const MAX_SLICES = 15;

const WheelComponent = ({
  unbox,
  winner,
  showSpin,
  boxPrice,
  boximage,
  setWinner,
  setRefetch,
  setShowSpin,
  spinnerData,
  boxFormatedPrice,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isDarkMode = useSelector((state) => state?.theme?.darkMode);
  const isLoggedIn = useSelector((state) => state?.auth?.isLoggedIn);
  const balance = useSelector((state) => state?.account?.balance);

  const [loading, setLoading] = useState(false);
  const [topUp, setTopup] = useState(false);
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const [isUnauthorized, setIsUnauthorized] = useState(false);
  const [preloadedImages, setPreloadedImages] = useState([]);
  const [arrowIcon, setArrowIcon] = useState(null);
  const [wheelItems, setWheelItems] = useState([]);
  const [showPostSpinModal, setShowPostSpinModal] = useState(false);

  const [toastMessage, setToastMessage] = useState(null);
  const [showNetworkError, setShowNetworkError] = useState(false);
  const [networkErrorType, setNetworkErrorType] = useState("network");
  const [isRefunding, setIsRefunding] = useState(false);
  const [currentSpinData, setCurrentSpinData] = useState(null);

  const animationRef = useRef(null);
  const spinCompleteRef = useRef(false);
  // const audioRef = useRef(null);
  const productRef = useRef({});
  const startAngleRef = useRef(0);
  const [activeSpin, setActiveSpin] = useState(null);
  const [showingPostModal, setShowingPostModal] = useState(false);
  const [spinComplete, setSpinComplete] = useState(false);
  const cancelSpinRef = useRef(false);
  const isMountedRef = useRef(true);
  const [buttonsBlocked, setButtonsBlocked] = useState(false);
  const spinInProgressRef = useRef(false);
  const [active, setActive] = useState(false);
  const isSpinningRef = useRef(false);
  const clickLockRef = useRef(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const audioContextRef = useRef(null);
  const audioBufferRef = useRef(null);
  const audioSourceRef = useRef(null);
  const gainNodeRef = useRef(null);

  const stopSpinSound = () => {
    if (audioSourceRef.current) {
      try {
        audioSourceRef.current.stop();
      } catch (_) {}
      audioSourceRef.current = null;
    }
  };

  useEffect(() => {
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    audioContextRef.current = new AudioContext();
    gainNodeRef.current = audioContextRef.current.createGain();
    gainNodeRef.current.connect(audioContextRef.current.destination);

    fetch(clickSound)
      .then((res) => res.arrayBuffer())
      .then((data) => audioContextRef.current.decodeAudioData(data))
      .then((buffer) => {
        audioBufferRef.current = buffer;
      })
      .catch((err) => console.error("Audio load failed", err));

    return () => {
      stopSpinSound();
      if (audioContextRef.current) {
        audioContextRef.current.close();
        audioContextRef.current = null;
      }
    };
  }, []);
  // Replace your unlock audio useEffect with this:
  useEffect(() => {
    const unlockAudio = async () => {
      if (audioContextRef.current?.state === "suspended") {
        try {
          await audioContextRef.current.resume();
          console.log("AudioContext resumed successfully");
        } catch (e) {
          console.error("Failed to resume AudioContext", e);
        }
      }
    };

    // Listen on multiple events
    const events = ["click", "touchstart", "touchend", "mousedown", "keydown"];

    events.forEach((event) => {
      window.addEventListener(event, unlockAudio, { once: false });
    });

    return () => {
      events.forEach((event) => {
        window.removeEventListener(event, unlockAudio);
      });
    };
  }, []);

  const startSpinSound = async (initialRate = 1.0) => {
    if (!audioContextRef.current || !audioBufferRef.current) return;

    // 🔥 FIX: Resume AudioContext FIRST and WAIT for it
    if (audioContextRef.current.state === "suspended") {
      try {
        await audioContextRef.current.resume();
      } catch (e) {
        console.error("Failed to resume AudioContext", e);
        return;
      }
    }

    stopSpinSound(); // Stop any existing sound

    const source = audioContextRef.current.createBufferSource();
    source.buffer = audioBufferRef.current;
    source.loop = true;
    source.playbackRate.value = initialRate;

    gainNodeRef.current.gain.value = 0.5;

    source.connect(gainNodeRef.current);
    source.start(0);

    audioSourceRef.current = source;
  };

  // Update playback rate dynamically
  const updateSpinSoundRate = (rate) => {
    if (audioSourceRef.current) {
      audioSourceRef.current.playbackRate.value = Math.max(0.1, rate);
    }
  };

  // Update volume dynamically
  const updateSpinSoundVolume = (volume) => {
    if (gainNodeRef.current) {
      gainNodeRef.current.gain.value = Math.max(0, Math.min(1, volume));
    }
  };
  const acquireSpinLock = () => {
    if (isSpinningRef.current || clickLockRef.current) {
      return false;
    }
    isSpinningRef.current = true;
    clickLockRef.current = true;
    setIsButtonDisabled(true);
    return true;
  };

  const releaseSpinLock = (delay = 0) => {
    isSpinningRef.current = false;
    if (delay > 0) {
      setTimeout(() => {
        if (isMountedRef.current) {
          clickLockRef.current = false;
          setIsButtonDisabled(false); // ADD THIS
        }
      }, delay);
    } else {
      clickLockRef.current = false;
      setIsButtonDisabled(false); // ADD THIS
    }
  };
  const wheelItemsRef = useRef([]);
  const winnerIndexRef = useRef(-1);

  // ✅ FUNCTION: Random 15 products select karo
  const selectRandomProducts = (allProducts, winningProduct = null) => {
    if (!allProducts || allProducts.length === 0) return [];

    let result = [];

    // Case 1: Products >= 15 → random 15
    if (allProducts.length >= MAX_SLICES) {
      result = [...allProducts]
        .sort(() => Math.random() - 0.5)
        .slice(0, MAX_SLICES);
    }
    // Case 2: Products < 15 → repeat randomly
    else {
      result = [...allProducts];

      while (result.length < MAX_SLICES) {
        const randomItem =
          allProducts[Math.floor(Math.random() * allProducts.length)];
        result.push(randomItem);
      }

      // Optional: final shuffle
      result = result.sort(() => Math.random() - 0.5);
    }

    // ✅ Ensure winner exists (agar pehle se diya gaya ho)
    if (winningProduct?.id) {
      const winnerId = winningProduct.id.toString();
      const exists = result.some((item) => item.id?.toString() === winnerId);

      if (!exists) {
        const randomIndex = Math.floor(Math.random() * MAX_SLICES);
        result[randomIndex] = winningProduct;
      }
    }

    return result;
  };

  // ✅ FUNCTION: Winner ko wheel mein add karo aur index return karo
  const ensureWinnerInWheel = (winningProduct, currentItems, allImages) => {
    if (!winningProduct || !winningProduct.id) {
      return { items: currentItems, winnerIndex: -1 };
    }

    const winningId = winningProduct.id.toString();

    // Check if winner already exists
    let winnerIndex = currentItems.findIndex(
      (item) => item?.id?.toString() === winningId,
    );

    if (winnerIndex !== -1) {
      // Winner already exists
      return { items: currentItems, winnerIndex };
    }

    // Winner nahi hai, add karo
    const winnerImage = allImages.find(
      (img) => img.id?.toString() === winningId,
    );

    if (winnerImage) {
      const newItems = [...currentItems];
      const randomIndex = Math.floor(Math.random() * newItems.length);
      newItems[randomIndex] = winnerImage;
      return { items: newItems, winnerIndex: randomIndex };
    }

    return { items: currentItems, winnerIndex: -1 };
  };
  const spin = async (value, type) => {
    spinCompleteRef.current = false;
    winnerIndexRef.current = -1;

    requestAnimationFrame(() => {
      if (isMountedRef.current) {
        drawWheel(startAngleRef.current);
      }
    });

    if (cancelSpinRef.current || !isMountedRef.current) {
      releaseSpinLock();
      return;
    }

    await ensureAudioContextReady();
    setCurrentSpinData({ value, type });
    setActiveSpin(type);
    setLoading(true);
    winnerIndexRef.current = -1;

    const spinningStartedRef = { current: false };
    rotateBackwardThenForward(spinningStartedRef);

    try {
      const result = await spinApiWithErrorHandling(value);

      if (cancelSpinRef.current || !isMountedRef.current) {
        smoothStopWheel();
        return;
      }

      productRef.current = result.product;

      const { items: updatedItems, winnerIndex } = ensureWinnerInWheel(
        result.product,
        wheelItemsRef.current,
        preloadedImages,
      );

      wheelItemsRef.current = updatedItems;
      winnerIndexRef.current = winnerIndex;
      setWheelItems(updatedItems);

      setWinner({
        unboxId: result.unboxId,
        winnerId: result.product?.id,
        product: result.product,
      });

      // ✅ FIXED: Wait for spinning to actually start
      const waitForSpin = () => {
        if (spinningStartedRef.current) {
          stopRotateWheelToProduct(value);
        } else {
          setTimeout(waitForSpin, 50); // Check every 50ms
        }
      };

      waitForSpin();
    } catch (error) {
      if (cancelSpinRef.current || !isMountedRef.current) return;
      smoothStopWheel();
      if (value === 900) await processRefund(value);
      setNetworkErrorType(error.type || "network");
      setShowNetworkError(true);
      spinInProgressRef.current = false;
    }
  };

  // ✅ Update rotateBackwardThenForward
  const rotateBackwardThenForward = (spinningStartedRef) => {
    const backwardAngle = -Math.PI / 3;
    const backwardDuration = active ? 300 : 600;
    const startTime = Date.now();
    const initialAngle = startAngleRef.current;

    const animateBackward = () => {
      if (!isMountedRef.current) return;
      const elapsed = Date.now() - startTime;
      const progress = Math.min(elapsed / backwardDuration, 1);
      const eased = easeOutCubic(progress);

      startAngleRef.current = initialAngle + backwardAngle * eased;
      drawWheel(startAngleRef.current);

      if (progress < 1) {
        animationRef.current = requestAnimationFrame(animateBackward);
      } else {
        // ✅ Mark that spinning has started
        if (spinningStartedRef) {
          spinningStartedRef.current = true;
        }
        keepSpinning();
      }
    };

    animationRef.current = requestAnimationFrame(animateBackward);
  };

  const stopRotateWheelToProduct = (value) => {
    const product = productRef.current;
    const items = wheelItemsRef.current;

    if (
      !product ||
      !product.id ||
      !isMountedRef.current ||
      items.length === 0
    ) {
      finishSpinAfterStop(value);
      return;
    }

    const productIdStr = product.id.toString();
    const sliceAngle = (2 * Math.PI) / items.length;

    let winningIndex = winnerIndexRef.current;
    if (winningIndex === -1) {
      winningIndex = items.findIndex(
        (item) => item?.id?.toString() === productIdStr,
      );
    }

    if (winningIndex === -1) {
      console.error("Winner not found in wheel items!");
      finishSpinAfterStop(value);
      return;
    }

    const sliceCenter = winningIndex * sliceAngle;
    const targetAngle = -Math.PI / 2 - sliceCenter;

    const extraRotations = active ? 2 * 2 * Math.PI : 3 * 2 * Math.PI;
    const initialAngle = startAngleRef.current;

    let finalTargetAngle = targetAngle + extraRotations;

    while (finalTargetAngle - initialAngle < 2 * Math.PI) {
      finalTargetAngle += 2 * Math.PI;
    }

    const totalDuration = active ? 400 : 1900;
    let startTime = null;

    if (animationRef.current) {
      cancelAnimationFrame(animationRef.current);
      animationRef.current = null;
    }

    const animateStop = (time) => {
      if (!isMountedRef.current) return;
      if (!startTime) startTime = time;

      const elapsed = time - startTime;
      const progress = Math.min(elapsed / totalDuration, 1);
      const easedProgress = active ? progress : easeOutCubic(progress);

      startAngleRef.current =
        initialAngle + (finalTargetAngle - initialAngle) * easedProgress;

      // 🔊 AUDIO SYNCHRONIZATION - same logic as before but using Web Audio API
      if (audioSourceRef.current) {
        if (active) {
          const currentSpeed = 1.0 - easedProgress * 0.95;
          updateSpinSoundRate(Math.max(1, currentSpeed * 1.0));

          if (easedProgress > 0.6) {
            updateSpinSoundVolume(1 * (2 - (easedProgress - 0.6) / 0.4));
            if (easedProgress > 0.75) {
              stopSpinSound();
            }
          }
        } else {
          const currentSpeed = 1.0 - easedProgress * 0.1;
          updateSpinSoundRate(Math.max(1, currentSpeed));

          if (value === 1500 && easedProgress > 0.85) {
            updateSpinSoundVolume(1 * (1 - (easedProgress - 0.85) / 0.15));
            if (easedProgress > 0.9) {
              stopSpinSound();
            }
          } else if (value === 900 && easedProgress > 0.9) {
            stopSpinSound();
          }
        }
      }

      drawWheel(startAngleRef.current);

      if (progress < 1) {
        animationRef.current = requestAnimationFrame(animateStop);
      } else {
        cancelAnimationFrame(animationRef.current);
        animationRef.current = null;

        startAngleRef.current = finalTargetAngle;
        drawWheel(finalTargetAngle);
        stopSpinSound();

        setTimeout(() => {
          if (isMountedRef.current) {
            spinCompleteRef.current = true;
            requestAnimationFrame(() => {
              if (isMountedRef.current) {
                drawWheel(startAngleRef.current);
              }
            });
          }
        }, 300);

        finishSpinAfterStop(value);
      }
    };

    animationRef.current = requestAnimationFrame(animateStop);

    setTimeout(() => {
      if (animationRef.current && isMountedRef.current) {
        cancelAnimationFrame(animationRef.current);
        animationRef.current = null;

        startAngleRef.current = finalTargetAngle;
        drawWheel(finalTargetAngle);
        stopSpinSound();

        setTimeout(() => {
          if (isMountedRef.current) {
            setSpinComplete(true);
            requestAnimationFrame(() => {
              if (isMountedRef.current) {
                drawWheel(startAngleRef.current);
              }
            });
          }
        }, 300);

        finishSpinAfterStop(value);
      }
    }, totalDuration + 1000);
  };

  const keepSpinning = async () => {
    const spinSpeed = active ? 0.5 : 0.25;

    // if (audioRef.current) {
    //   audioRef.current.currentTime = 0;
    //   audioRef.current.playbackRate = active ? 2.0 : 1.0;
    //   audioRef.current.play().catch(() => {});
    // }
    await startSpinSound(active ? 1.0 : 1.0);

    const animate = () => {
      if (!isMountedRef.current) return;
      startAngleRef.current += spinSpeed;
      drawWheel(startAngleRef.current);
      animationRef.current = requestAnimationFrame(animate);
    };
    animationRef.current = requestAnimationFrame(animate);
  };
  const ensureAudioContextReady = async () => {
    if (audioContextRef.current?.state === "suspended") {
      await audioContextRef.current.resume();
    }
  };
  const smoothStopWheel = () => {
    if (animationRef.current) {
      cancelAnimationFrame(animationRef.current);
      animationRef.current = null;
    }

    if (!isMountedRef.current) return;

    const initialSpeed = 0.12;
    const deceleration = 0.97;
    let currentSpeed = initialSpeed;

    const smoothStop = () => {
      if (!isMountedRef.current) return;

      currentSpeed *= deceleration;
      startAngleRef.current += currentSpeed;
      drawWheel(startAngleRef.current);

      // Sync sound with deceleration
      if (audioSourceRef.current) {
        const normalizedSpeed = currentSpeed / initialSpeed;
        updateSpinSoundRate(Math.max(0.3, normalizedSpeed));

        if (normalizedSpeed < 0.15) {
          updateSpinSoundVolume(normalizedSpeed * 3.33);
          if (normalizedSpeed < 0.05) {
            stopSpinSound();
          }
        }
      }

      if (currentSpeed > 0.01) {
        animationRef.current = requestAnimationFrame(smoothStop);
      } else {
        stopSpinSound();

        if (isMountedRef.current) {
          setActiveSpin(null);
          setLoading(false);
          spinInProgressRef.current = false;
          setButtonsBlocked(false);
        }
      }
    };

    releaseSpinLock(2500);
    animationRef.current = requestAnimationFrame(smoothStop);
  };
  const checkNetworkConnection = () => {
    return navigator.onLine;
  };

  // ✅ Component Unmount Cleanup
  useEffect(() => {
    isMountedRef.current = true;

    return () => {
      isMountedRef.current = false;
      cancelSpinRef.current = true;
      spinInProgressRef.current = false;

      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
        animationRef.current = null;
      }

      // if (audioRef.current) {
      //   audioRef.current.pause();
      //   audioRef.current.currentTime = 0;
      // }

      setLoading(false);
      setActiveSpin(null);
      setShowNetworkError(false);
      setIsRefunding(false);
      setCurrentSpinData(null);
    };
  }, []);

  // Handle logout during spin
  useEffect(() => {
    if (!isLoggedIn) {
      cancelSpinRef.current = true;
      spinInProgressRef.current = false;

      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
        animationRef.current = null;
      }

      // if (audioRef.current) {
      //   audioRef.current.pause();
      //   audioRef.current.currentTime = 0;
      // }

      setLoading(false);
      setActiveSpin(null);
      setButtonsBlocked(false);
    } else {
      cancelSpinRef.current = false;
    }
  }, [isLoggedIn]);

  // Handle box switch
  useEffect(() => {
    cancelSpinRef.current = true;
    spinInProgressRef.current = false;

    if (animationRef.current) {
      cancelAnimationFrame(animationRef.current);
      animationRef.current = null;
    }

    // if (audioRef.current) {
    //   audioRef.current.pause();
    //   audioRef.current.currentTime = 0;
    // }

    setLoading(false);
    setActiveSpin(null);
    setShowNetworkError(false);
    setIsRefunding(false);
    setCurrentSpinData(null);
    setButtonsBlocked(false);
    winnerIndexRef.current = -1;

    setTimeout(() => {
      if (isMountedRef.current) {
        cancelSpinRef.current = false;
      }
    }, 100);
  }, [unbox?.id]);

  // Preload arrow
  useEffect(() => {
    const img = new Image();
    img.src = arrow;
    img.onload = () => {
      if (isMountedRef.current) {
        setArrowIcon(img);
      }
    };
  }, []);

  // useEffect(() => {
  //   audioRef.current = new Audio(clickSound);
  //   audioRef.current.volume = 0.5;
  //   audioRef.current.loop = false;
  // }, []);

  // Preload spinner images
  useEffect(() => {
    let loaded = 0;
    const imgs = spinnerData.map((item) => {
      const img = new window.Image();
      img.src = item.image;
      img.id = item.id;
      img.price = item.price;
      img.onload = () => {
        loaded++;
        if (loaded === spinnerData.length && isMountedRef.current) {
          setImagesLoaded(true);
          setPreloadedImages(imgs);
        }
      };
      img.onerror = () => {
        loaded++;
        if (loaded === spinnerData.length && isMountedRef.current) {
          setImagesLoaded(true);
          setPreloadedImages(imgs);
        }
      };
      return img;
    });
  }, [spinnerData]);

  // ✅ UPDATED: Prepare wheel items - Always 15 slices
  useEffect(() => {
    if (!imagesLoaded || preloadedImages.length === 0) return;

    // Random 15 products select karo
    const selectedProducts = selectRandomProducts(preloadedImages, null);

    // ✅ Both state aur ref update karo
    setWheelItems(selectedProducts);
    wheelItemsRef.current = selectedProducts;

    startAngleRef.current = -Math.PI / 2;
    productRef.current = {};
    winnerIndexRef.current = -1;
  }, [imagesLoaded, preloadedImages]);

  // ✅ Sync wheelItems state with ref
  useEffect(() => {
    wheelItemsRef.current = wheelItems;
  }, [wheelItems]);

  useEffect(() => {
    const originalPush = navigate;
    const originalReplace = navigate;

    const blockedNavigate = (to, options) => {
      if (spinInProgressRef.current) {
        alert("Please wait — the wheel is still spinning!");
        return;
      }
      return originalPush(to, options);
    };

    navigate.push = blockedNavigate;
    navigate.replace = blockedNavigate;

    return () => {
      navigate.push = originalPush;
      navigate.replace = originalReplace;
    };
  }, [navigate]);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (spinInProgressRef.current) {
        event.preventDefault();
        event.returnValue =
          "The wheel is spinning. Please wait for it to finish.";
        return event.returnValue;
      }
    };

    const handlePopState = (event) => {
      if (spinInProgressRef.current) {
        window.history.pushState(null, "", window.location.href);
        event.preventDefault();
      }
    };

    const handleKeyDown = (e) => {
      if (
        spinInProgressRef.current &&
        (e.key === "F5" ||
          (e.ctrlKey && (e.key === "r" || e.key === "R")) ||
          (e.metaKey && e.key === "r"))
      ) {
        e.preventDefault();
        e.stopPropagation();
      }
    };

    window.history.pushState(null, "", window.location.href);
    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("popstate", handlePopState);
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handlePopState);
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const ref = () => document?.getElementById("canvas")?.getContext("2d");

  const spinApiWithErrorHandling = async (value) => {
    return new Promise(async (resolve, reject) => {
      if (!isMountedRef.current) {
        reject({ type: "cancelled", message: "Component unmounted" });
        return;
      }

      if (!checkNetworkConnection()) {
        reject({ type: "network", message: "No internet connection" });
        return;
      }

      const timeoutId = setTimeout(() => {
        reject({ type: "timeout", message: "Request timed out" });
      }, 10000);

      try {
        let response;
        if (value === 900) {
          response = await spinWheel(
            unbox?.id,
            unbox?.version,
            unbox?.promotion_redemption_id,
          );
          if (response?.data?.message === "Your balance is insufficient") {
            setToastMessage({ error: response?.data?.message });
            // fetchBalance();
            // return;
          }
          if (response.data.message === "Unauthenticated.") {
            setIsUnauthorized(true);
          }
          fetchBalance();
        } else if (value === 1500) {
          response = await spinFree(unbox?.id);
          if (response.data.message === "Unauthenticated.") {
            setIsUnauthorized(true);
          }
        }

        clearTimeout(timeoutId);

        if (!isMountedRef.current) {
          reject({ type: "cancelled", message: "Component unmounted" });
          return;
        }

        if (!response || !response.data || !response.data.data) {
          reject({ type: "api", message: "Invalid API response" });
          return;
        }

        let product;

        if (Array.isArray(response?.data?.data)) {
          product = response.data.data[0]?.product;
        } else {
          product = response?.data?.data?.product;
        }

        if (!product) {
          reject({ type: "api", message: "No product data received" });
          return;
        }

        resolve({
          product,
          unboxId: response?.data?.data?.unbox_id,
        });
      } catch (error) {
        clearTimeout(timeoutId);

        if (error.code === "NETWORK_ERROR" || !navigator.onLine) {
          reject({ type: "network", message: "Network connection error" });
        } else if (
          error.code === "ECONNABORTED" ||
          error.message.includes("timeout")
        ) {
          reject({ type: "timeout", message: "Request timed out" });
        } else {
          reject({ type: "api", message: "Server error occurred" });
        }
      }
    });
  };

  const processRefund = async (spinValue) => {
    setIsRefunding(true);

    try {
      if (spinValue === 900 && isLoggedIn) {
        await fetchBalance();
      }
    } catch (error) {
      console.error("Refund processing error:", error);
    } finally {
      if (isMountedRef.current) {
        setIsRefunding(false);
        spinInProgressRef.current = false;
        setButtonsBlocked(false);
      }
    }
  };

  const handleRetryFromError = () => {
    setShowNetworkError(false);
    setIsRefunding(false);
    setRefetch(true);

    if (currentSpinData) {
      // Reset lock before retry
      isSpinningRef.current = false;
      clickLockRef.current = false;

      setTimeout(() => {
        if (acquireSpinLock()) {
          spin(currentSpinData.value, currentSpinData.type);
        }
      }, 500);
    } else {
      releaseSpinLock();
    }
  };

  const handleCancelFromError = () => {
    setShowNetworkError(false);
    setIsRefunding(false);
    setCurrentSpinData(null);
    releaseSpinLock();
  };
  function getCanvasGradient(
    ctx,
    centerX,
    centerY,
    halfHeight,
    gradientString,
  ) {
    const matches = [
      ...gradientString.matchAll(/rgba?\([^)]+\)|#[0-9a-fA-F]{3,8}/g),
    ];
    const colorStops = matches.map((m) => m[0]);

    if (colorStops.length < 2) return colorStops[0] || "#333";

    const angleMatch = gradientString.match(/(\d+)deg/);
    const angle = angleMatch ? parseInt(angleMatch[1]) : 180;

    const radians = ((angle - 90) * Math.PI) / 180;

    // ✅ Coordinates relative to (centerX, centerY) = (0, 0) in local space
    const x1 = centerX + Math.cos(radians + Math.PI) * halfHeight;
    const y1 = centerY + Math.sin(radians + Math.PI) * halfHeight;
    const x2 = centerX + Math.cos(radians) * halfHeight;
    const y2 = centerY + Math.sin(radians) * halfHeight;

    const grad = ctx.createLinearGradient(x1, y1, x2, y2);
    grad.addColorStop(0, colorStops[0]);
    grad.addColorStop(1, colorStops[1]);

    return grad;
  }
  // ✅ UPDATED: drawWheel uses wheelItemsRef for accurate rendering
  const drawWheel = (currentAngle = startAngleRef.current) => {
    const ctx = ref();
    const items = wheelItemsRef.current;

    if (!ctx || !items.length || !arrowIcon || !isMountedRef.current) return;

    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);

    const centerX = ctx.canvas.width / 2;
    const centerY = ctx.canvas.height / 2 + 335;

    const outsideRadius = 350;
    const insideRadius = 530;

    const totalArc = (2 * Math.PI) / items.length;
    const gapAngle = (6 * Math.PI) / 180;
    const adjustedAngle = currentAngle - totalArc / 2;

    const radius = (outsideRadius + insideRadius) / 2;

    const cardWidth = 144;
    const cardHeight = 144;
    const cardRadius = 20;

    let winningItemData = null;

    for (let i = 0; i < items.length; i++) {
      const angle = adjustedAngle + i * totalArc + gapAngle / 2;
      const sliceMidAngle = angle + (totalArc - gapAngle) / 2;

      const product = items[i];
      const price = product?.price;

      const lightBgColor = (price) => {
        if (price <= 20) return globalGradientLightColors.softGrayGlow;
        if (price <= 50) return globalGradientLightColors.softCyanRadiance;
        if (price <= 250) return globalGradientLightColors.softPeriwinkleGlow;
        if (price <= 2000) return globalGradientLightColors.softLilacRadiance;
        return globalGradientLightColors.softVanillaGlow;
      };

      const darkBgColor = (price) => {
        if (price <= 20) return globalGradientDarkColorsWheel.commanGray;
        if (price <= 50) return globalGradientDarkColorsWheel.greenUncomman;
        if (price <= 250) return globalGradientDarkColorsWheel.blueRare;
        if (price <= 2000) return globalGradientDarkColorsWheel.purpleEpic;
        return globalGradientDarkColorsWheel.goldLegendary;
      };

      const bgColor = isDarkMode ? darkBgColor(price) : lightBgColor(price);

      const x = centerX + Math.cos(sliceMidAngle) * radius;
      const y = centerY + Math.sin(sliceMidAngle) * radius;

      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(sliceMidAngle + Math.PI / 2);

      // 1. Shadow
      ctx.shadowColor = "rgba(0,0,0,0.25)";
      ctx.shadowBlur = 20;
      ctx.shadowOffsetY = 10;

      // 2. Draw card background
      drawRoundedRect(
        ctx,
        -cardWidth / 2,
        -cardHeight / 2,
        cardWidth,
        cardHeight,
        cardRadius,
      );
      ctx.fillStyle = getCanvasGradient(ctx, 0, 0, cardHeight / 2, bgColor);
      ctx.fill();

      // 3. Reset shadow before border
      ctx.shadowColor = "transparent";
      ctx.shadowBlur = 0;
      ctx.shadowOffsetY = 0;

      // 4. Top border — solid, clipped by rounded corners naturally
      ctx.save();
      drawRoundedRect(
        ctx,
        -cardWidth / 2,
        -cardHeight / 2,
        cardWidth,
        cardHeight,
        cardRadius,
      );
      ctx.clip();
      ctx.fillStyle = getPriceDarkBorderColor(price);
      ctx.fillRect(-cardWidth / 2, -cardHeight / 2, cardWidth, 1);
      ctx.restore();

      ctx.restore();

      // 6. Draw product image
      if (product?.complete && product.naturalWidth > 0) {
        ctx.save();
        ctx.translate(x, y);
        ctx.rotate(sliceMidAngle + Math.PI / 2);

        const imgSize = 80;
        ctx.drawImage(product, -imgSize / 2, -imgSize / 2, imgSize, imgSize);

        ctx.restore();
      }
    }

    const fixedBorderX = centerX;
    const fixedBorderY = centerY - (outsideRadius + insideRadius) / 2; // same radius as cards

    const gap = 8;
    const fixedCardWidth = cardWidth + gap * 2;
    const fixedCardHeight = cardHeight + gap * 2;
    const fixedCardRadius = cardRadius + gap;

    ctx.save();
    ctx.translate(fixedBorderX, fixedBorderY);

    drawRoundedRect(
      ctx,
      -fixedCardWidth / 2,
      -fixedCardHeight / 2,
      fixedCardWidth,
      fixedCardHeight,
      fixedCardRadius,
    );
    ctx.lineWidth = 4;
    ctx.strokeStyle = "#FFCB21";
    ctx.stroke();
    ctx.restore();

    if (spinCompleteRef.current) {
      const centeredIndex =
        ((Math.round(-startAngleRef.current / totalArc) % items.length) +
          items.length) %
        items.length;
      const item = items[centeredIndex];
      if (item) {
        winningItemData = { x: fixedBorderX, y: fixedBorderY };
        winnerIndexRef.current = centeredIndex;
      }
    }

    // 7. Draw arrow
    if (arrowIcon) {
      const arrowOffset = 192;

      ctx.save();
      ctx.translate(centerX, centerY - outsideRadius - arrowOffset);

      const width = 48;
      const height = 26.67;

      ctx.drawImage(arrowIcon, -width / 2, -height, width, height);

      ctx.restore();
    }

    // 8. Price badge for winner
    if (winningItemData) {
      const { x, y } = winningItemData;
      const item = items[winnerIndexRef.current];

      const priceText = `$${item.price.toFixed(2)}`;

      ctx.font = "bold 18px Space Grotesk, sans-serif";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";

      const paddingX = 12;
      const textWidth = ctx.measureText(priceText).width;
      const badgeWidth = textWidth + paddingX * 2;
      const badgeHeight = 30;

      const badgeX = x - badgeWidth / 2;
      const badgeY = y + 90;

      ctx.save();
      ctx.fillStyle = "#FFCB21";
      drawRoundedRect(ctx, badgeX, badgeY, badgeWidth, badgeHeight, 16);
      ctx.fill();
      ctx.restore();

      ctx.fillStyle = "#0D0D0D";
      ctx.fillText(priceText, x, badgeY + badgeHeight / 2);
    }
  };
  function drawRoundedRect(ctx, x, y, width, height, radius) {
    ctx.beginPath();
    ctx.moveTo(x + radius, y);
    ctx.lineTo(x + width - radius, y);
    ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
    ctx.lineTo(x + width, y + height - radius);
    ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
    ctx.lineTo(x + radius, y + height);
    ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
    ctx.lineTo(x, y + radius);
    ctx.quadraticCurveTo(x, y, x + radius, y);
    ctx.closePath();
  }
  const easeOutCubic = (t) => --t * t * t + 1;
  useEffect(() => {
    return () => {
      stopSpinSound();

      if (audioContextRef.current) {
        audioContextRef.current.close();
        audioContextRef.current = null;
      }
    };
  }, []);

  const finishSpinAfterStop = async (value) => {
    if (!isMountedRef.current) return;
    stopSpinSound();
    setActiveSpin(null);
    setLoading(false);
    setCurrentSpinData(null);

    // if (audioRef.current) {
    //   audioRef.current.pause();
    //   audioRef.current.currentTime = 0;
    //   audioRef.current.playbackRate = 1.0;
    // }

    if (value === 900) {
      setTimeout(() => {
        setShowSpin(!showSpin);
      }, 1000);
    }
    const updated = await syncUserData();
    if (updated) {
      dispatch(updateUserData(updated));
    }

    await fetchBalance();
    await new Promise((resolve) => setTimeout(resolve, 500));

    if (isMountedRef.current) {
      spinInProgressRef.current = false;
      setButtonsBlocked(false);
      releaseSpinLock(2500);
    }
  };

  useEffect(() => {
    if (!imagesLoaded || !arrowIcon || wheelItems.length === 0) return;

    const ctx = ref();
    if (!ctx) return;

    drawWheel();
  }, [imagesLoaded, arrowIcon, wheelItems, isDarkMode]);

  const warmUpAudio = () => {
    // if (audioRef.current && audioRef.current.paused) {
    //   audioRef.current
    //     .play()
    //     .then(() => {
    //       audioRef.current.pause();
    //       audioRef.current.currentTime = 0;
    //     })
    //     .catch(() => {});
    // }
  };

  useEffect(() => {
    const handleUserInteraction = () => {
      warmUpAudio();
      window.removeEventListener("click", handleUserInteraction);
    };

    window.addEventListener("click", handleUserInteraction);

    return () => {
      window.removeEventListener("click", handleUserInteraction);
    };
  }, []);

  useEffect(() => {
    if (imagesLoaded && arrowIcon && wheelItems.length > 0) {
      requestAnimationFrame(() => {
        if (isMountedRef.current) {
          drawWheel(startAngleRef.current);
        }
      });
    }
  }, [spinComplete]);

  const handleUnbox = async () => {
    if (!acquireSpinLock()) {
      return;
    }
    await ensureAudioContextReady();

    if (isLoggedIn) {
      if (
        parseFloat(balance) >= parseFloat(boxPrice) ||
        unbox?.hidden_from_shop
      ) {
        spin(900, "paid");
      } else {
        setTopup(true);
        releaseSpinLock();
      }
    } else {
      dispatch(toggleOnboard({ login: true }));
      releaseSpinLock();
    }
  };

  function debounce(func, delay) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  }

  const handleFreeSpin = async () => {
    if (!acquireSpinLock()) {
      return;
    }
    await ensureAudioContextReady();

    spin(1500, "free");
  };
  const handleClosePostSpinModal = () => {
    setShowPostSpinModal(false);
    setShowingPostModal(false);
  };

  const handleLoginFromModal = () => {
    setShowPostSpinModal(false);
    setShowingPostModal(false);
    dispatch(toggleOnboard({ login: true }));
  };

  const handleTopUpFromModal = () => {
    setShowPostSpinModal(false);
    setShowingPostModal(false);
    setTopup(true);
  };

  const fetchBalance = async () => {
    try {
      const response = await getAccountBalance();
      const accountData = response?.data?.data;

      if (accountData && isMountedRef.current) {
        dispatch(
          setAccount({
            balance: parseFloat(accountData.balance) || 0,
            current_xp: accountData.current_xp || 0,
            level: accountData.level || 0,
            next_level_xp: accountData.next_level_xp || 0,
            next_level: accountData.next_level || 0,
            current_progress: accountData.current_progress || 0,
            formatted_balance: accountData.formatted_balance || "0",
          }),
        );
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <Toaster message={toastMessage} />
      {!imagesLoaded ? (
        <div className="loading-wheel-assets">
          Loading wheel assets...
          <Loading />
        </div>
      ) : (
        <>
          <div className="spin-header container">
            <button
              className="spin-header__back"
              onClick={() => {
                if (window.history.length > 1) {
                  navigate(-1);
                } else {
                  navigate(routes.HOME);
                }
              }}
            >
              <ChevronLeft size={18} />
            </button>

            <div className="spin-header__center">
              <img className="spin-header__img" src={boximage} alt="box" />
              <div className="spin-header__info">
                <span className="spin-header__name">{unbox?.name}</span>
                <span className="spin-header__price">
                  {unbox?.hidden_from_shop ? "Free Box" : `${boxFormatedPrice}`}
                </span>
              </div>
            </div>

            <button
              className="spin-header__fairness"
              onClick={() => navigate(routes.PROVABLYFAIR)}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10.43 1.80815C10.3139 1.69808 10.16 1.63672 10 1.63672C9.84001 1.63672 9.68611 1.69808 9.57001 1.80815C7.80106 3.48805 5.44511 4.40926 3.00584 4.37482C2.87295 4.37309 2.74297 4.41377 2.63478 4.49094C2.52658 4.56812 2.4458 4.67777 2.40417 4.80398C2.05248 5.87579 1.87385 6.99679 1.87501 8.12482C1.87501 13.0765 5.26167 17.2357 9.84417 18.4148C9.94639 18.4412 10.0536 18.4412 10.1558 18.4148C14.7383 17.2357 18.125 13.0765 18.125 8.12482C18.125 6.96648 17.9392 5.84982 17.5958 4.80398C17.5544 4.67762 17.4736 4.56778 17.3654 4.49045C17.2572 4.41311 17.1272 4.37231 16.9942 4.37398L16.875 4.37482C14.3783 4.37482 12.1108 3.39982 10.43 1.80815ZM13.0083 8.48815C13.0583 8.42153 13.0945 8.34558 13.1147 8.26477C13.135 8.18397 13.1388 8.09993 13.1261 8.01761C13.1134 7.93529 13.0844 7.85634 13.0407 7.7854C12.9971 7.71446 12.9397 7.65296 12.8719 7.60453C12.8041 7.55609 12.7274 7.52169 12.6461 7.50334C12.5648 7.485 12.4807 7.48308 12.3987 7.4977C12.3167 7.51232 12.2385 7.54319 12.1686 7.58849C12.0987 7.63379 12.0385 7.69261 11.9917 7.76148L9.29501 11.5365L7.94167 10.1832C7.82319 10.0728 7.66649 10.0126 7.50457 10.0155C7.34265 10.0184 7.18817 10.084 7.07365 10.1985C6.95914 10.313 6.89355 10.4675 6.89069 10.6294C6.88784 10.7913 6.94794 10.948 7.05834 11.0665L8.93334 12.9415C8.9975 13.0056 9.07484 13.055 9.16 13.0862C9.24515 13.1174 9.33608 13.1297 9.42647 13.1223C9.51687 13.1148 9.60455 13.0878 9.68345 13.043C9.76234 12.9983 9.83055 12.9369 9.88334 12.8632L13.0083 8.48815Z"
                  fill="#A6A6A6"
                />
              </svg>
              Fairness
            </button>
          </div>
          <div
            style={{
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundImage: `url(${SpinBackground})`,
              // backgroundImage: isDarkMode
              //   ? unbox?.box_background_images?.dark_theme?.background_image
              //     ? `url(${unbox.box_background_images.dark_theme.background_image})`
              //     : "none"
              //   : unbox?.box_background_images?.background_image
              //     ? `url(${unbox.box_background_images.background_image})`
              //     : "none",
            }}
            className={`mainCanvas ${isDarkMode ? "dark" : "light"}`}
          >
            <canvas
              id="canvas"
              className="canvas"
              width="1900"
              height="456"
            ></canvas>

            {/* Bottom Content Section - INSIDE mainCanvas */}
            <div className="bottom-content-section">
              <div className="buttons-container">
                {/* {!unbox.hidden_from_shop && ( */}
                <button
                  disabled={isButtonDisabled}
                  onClick={handleFreeSpin}
                  className="spinnerButton try-free-btn"
                  onMouseEnter={warmUpAudio}
                >
                  <RefreshCw
                    className={`btn-icon ${
                      loading && activeSpin === "free" ? "animate-spin" : ""
                    }`}
                  />
                  Try Free
                </button>
                {/* )} */}

                <div
                  onClick={() => !isButtonDisabled && setActive(!active)}
                  className={`button-zap
                    ${active ? "active" : ""}
                    ${isButtonDisabled ? "cursor-disabled" : ""}
                    `}
                  style={{ pointerEvents: isButtonDisabled ? "none" : "auto" }}
                >
                  <Zap className="icon-zap" />
                </div>

                <button
                  onClick={handleUnbox}
                  onMouseEnter={warmUpAudio}
                  className="spinnerButton unbox-btn"
                  disabled={
                    isButtonDisabled ||
                    (!unbox?.promotion_redemption_id && unbox?.hidden_from_shop)
                  }
                >
                  {unbox?.hidden_from_shop
                    ? "Open For Free"
                    : `Open Box for ${boxFormatedPrice}`}
                </button>
              </div>
            </div>
          </div>
        </>
      )}

      <NetworkErrorModal
        show={showNetworkError}
        isRefunding={isRefunding}
        errorType={networkErrorType}
        onLogin={handleLoginFromModal}
        onRetry={handleRetryFromError}
        isUnauthorized={isUnauthorized}
        onCancel={handleCancelFromError}
      />

      <PostSpinModal
        isLoggedIn={isLoggedIn}
        show={showPostSpinModal}
        onLogin={handleLoginFromModal}
        onTopUp={handleTopUpFromModal}
        onClose={handleClosePostSpinModal}
        hasEnoughBalance={parseFloat(balance) >= parseFloat(boxPrice)}
      />

      <TopUpModal setTopUpModalShow={setTopup} show={topUp} />
    </>
  );
};

export default WheelComponent;
